(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-product-columns"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function shouldUseSlider() {
      return window.innerWidth <= 900;
    }

    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
        if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

        const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
        const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
        const loop = el.dataset.blazeLoop === 'true';
        const draggable = el.dataset.blazeDraggable === 'true';

        new BlazeSlider(el, {
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
        });

        el.classList.add('blaze-initialized');
      });
    }

    function destroyBlazeSliders(target = document) {
      target.querySelectorAll('.blaze-initialized').forEach((el) => {
        const track = el.querySelector('.blaze-track');
        if (!track) return;

        const restoredGrid = track.cloneNode(true);
        restoredGrid.className = 'flexi-columns-grid';
        el.parentNode.replaceChild(restoredGrid, el);
      });
    }

    function handleResize() {
      if (shouldUseSlider()) {
        initBlazeSliders();
      } else {
        destroyBlazeSliders();
      }
    }

    // Initial run
    handleResize();

    // On section load (e.g., theme editor)
    document.addEventListener('shopify:section:load', function (event) {
      handleResize(event.target);
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-now"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    // Skip if it's a bundle buy now button - those are handled separately
    if (e.target.matches('[data-bundle-buy-now="true"]') || e.target.closest('[data-bundle-buy-now="true"]')) {
      return;
    }

    if (e.target.matches('[data-buy-now="true"]') || e.target.closest('[data-buy-now="true"]')) {
      e.preventDefault();
      const button = e.target.closest('[data-buy-now="true"]') || e.target;
      const form = button.closest('form');
      if (form) {
        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        }).then(function() {
          window.location.href = '/checkout';
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social-share"] && !Shopify.designMode) return;
  try {
    (function() {
    console.log('[social-share] Script loaded v2');
    // Bookmarks stored in customer metafields via App Proxy
    // Proxy endpoint: /apps/bookmarks (uses Admin API on backend)

    function showNotification(message) {
      const existing = document.querySelector('.bookmark-notification');
      if (existing) existing.remove();

      const notification = document.createElement('div');
      notification.className = 'bookmark-notification';
      notification.textContent = message;
      document.body.appendChild(notification);

      setTimeout(() => {
        notification.classList.add('bookmark-notification--hiding');
        setTimeout(() => notification.remove(), 300);
      }, 2500);
    }

    // Fetch bookmarks via App Proxy
    async function getBookmarks() {
      console.log('Fetching bookmarks from App Proxy...');
      try {
        const response = await fetch('/apps/bookmarks');
        console.log('Fetch response status:', response.status);
        if (!response.ok) {
          console.error('Fetch failed with status:', response.status);
          return [];
        }
        const data = await response.json();
        console.log('Fetched bookmarks:', data);
        return data.bookmarks || [];
      } catch (error) {
        console.error('Bookmark fetch failed:', error);
        return [];
      }
    }

    // Save bookmarks via App Proxy
    async function saveBookmarks(bookmarks) {
      console.log('Saving bookmarks via App Proxy:', bookmarks);
      try {
        const response = await fetch('/apps/bookmarks', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ bookmarks })
        });
        console.log('Save response status:', response.status);
        const text = await response.text();
        console.log('Save response raw:', text);
        let data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          console.error('Failed to parse response as JSON:', e);
          return false;
        }
        console.log('Save response data:', data);
        if (!response.ok) {
          console.error('Save failed:', response.status, data);
          return false;
        }
        return data.success === true;
      } catch (error) {
        console.error('Bookmark save failed:', error);
        return false;
      }
    }

    function initSocialShare() {
      document.querySelectorAll('[data-social-share]').forEach(root => {
        if (root._socialShareBound) return;
        root._socialShareBound = true;

        const link = root.getAttribute('data-social-share-link') || location.href;
        const title = root.getAttribute('data-social-share-title') || document.title;

        root.addEventListener('click', async (e) => {
          const btn = e.target.closest('[data-social-share-type]');
          if (!btn) return;
          e.preventDefault();

          const type = btn.getAttribute('data-social-share-type');
          const u = encodeURIComponent(link);
          const t = encodeURIComponent(title);

          // Handle bookmark (requires login via App Proxy)
          if (type === 'bookmark') {
            // Redirect to login if not logged in
            if (btn.hasAttribute('data-require-login')) {
              window.location.href = '/account/login';
              return;
            }

            const blogHandle = root.getAttribute('data-blog-handle');
            const articleHandle = root.getAttribute('data-article-handle');
            if (!articleHandle || !blogHandle) return;

            // Build article object with all data
            const articleData = {
              handle: articleHandle,
              blogHandle: blogHandle,
              title: root.getAttribute('data-article-title') || '',
              excerpt: root.getAttribute('data-article-excerpt') || '',
              image: root.getAttribute('data-article-image') || '',
              url: `/blogs/${blogHandle}/${articleHandle}`
            };

            btn.disabled = true;
            const isActive = btn.getAttribute('aria-pressed') === 'true';

            // Fetch current bookmarks
            let bookmarks = await getBookmarks();

            if (isActive) {
              // Remove by handle
              bookmarks = bookmarks.filter(b => {
                const h = typeof b === 'string' ? b : b.handle;
                return h !== articleHandle;
              });
              showNotification('Article removed from saved');
            } else {
              // Add full article data
              const exists = bookmarks.some(b => {
                const h = typeof b === 'string' ? b : b.handle;
                return h === articleHandle;
              });
              if (!exists) {
                bookmarks.push(articleData);
              }
              showNotification('Article saved');
            }

            const success = await saveBookmarks(bookmarks);

            if (success) {
              btn.setAttribute('aria-pressed', String(!isActive));
              btn.classList.toggle('social-share__button--active', !isActive);
              window.dispatchEvent(new CustomEvent('bookmarks:updated', {
                detail: { bookmarks, articleHandle, action: isActive ? 'removed' : 'added' }
              }));
            } else {
              showNotification('Failed to save. Please try again.');
            }

            btn.disabled = false;
            return;
          }

          const map = {
            x: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
            linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
            reddit: `https://www.reddit.com/submit?url=${u}&title=${t}`,
            telegram: `https://t.me/share/url?url=${u}&text=${t}`,
            whatsapp: `https://api.whatsapp.com/send?text=${t}%20${u}`,
            mail: `mailto:?subject=${t}&body=${t}%0A%0A${u}`,
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
            pinterest: `https://www.pinterest.com/pin/create/button/?url=${u}&description=${t}`,
          };

          if (type === 'clipboard' || type === 'instagram') {
            navigator.clipboard.writeText(link).then(() => {
              btn.setAttribute('data-social-share-success', '');
              setTimeout(() => btn.removeAttribute('data-social-share-success'), 2000);
            });
            return;
          }

          const url = map[type];
          if (url) window.open(url, '_blank', 'noopener,noreferrer');
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSocialShare);
    } else {
      initSocialShare();
    }

    document.addEventListener('shopify:section:load', initSocialShare);
  })();
  } catch(e) { console.error(e); }
})();

})();
